import React, { useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ATitle from "core/presentation/components/Title";
import { Select } from "antd";
import AText from "core/presentation/components/Text";
import { color } from "theme/Color";
import "./chart.css";
import PieChart from "core/presentation/components/PieChartComponent";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);
const { Option } = Select;

type MaterialType = "Material" | "Location" | "Inward/Outward";

export function TotalOrdersChart(materials : any) {
  const [material, setMaterial] = useState<MaterialType>("Material");

  const handleChange = (value: MaterialType) => {
    setMaterial(value);
  };

  const getMaterialData = () => {
    const materialName = materials?.materials?.countMaterial?.map((item : any) => item.material);
  const counts = materials?.materials?.countMaterial?.map((item : any) => parseInt(item.count, 10)); // Convert string counts to integers

    // Function to generate a random hex color
    const getRandomColor = () => {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };
  
    // Generate a color for each material
    const backgroundColors = materials?.materials?.countMaterial?.map(() => getRandomColor());

    const data =  {
      labels: materialName,
      datasets: [
        {
          label: "# of Materials",
          data: counts,
          backgroundColor: backgroundColors,
          borderWidth: 1,
        },
      ],
    };
    return data
  };
  const getTotalCount = () => {
    // Sum the counts of all materials
    return materials?.materials?.countMaterial?.reduce((total : any, item : any) => {
      return total + parseInt(item.count, 10); // Convert string counts to integers
    }, 0);
  };
  const getLocationData = () => {
    return {
      labels: ["Kathmandu", "Bhairahawa", "Chitwan"],
      datasets: [
        {
          label: "# of Locations",
          data: [30, 20, 50],
          backgroundColor: ["#F765A3", "#16BFD6", "#165BAA"],
          borderWidth: 1,
        },
      ],
    };
  };

  const getInwardOutwardData = () => {
    return {
      labels: ["Inward", "Outward"],
      datasets: [
        {
          label: "# of Orders",
          data: [60, 40],
          backgroundColor: ["#F765A3", "#16BFD6"],
          borderWidth: 1,
        },
      ],
    };
  };

  const getChartData = () => {
    switch (material) {
      case "Material":
        return getMaterialData();
      // case "Location":
      //   return getLocationData();
      // case "Inward/Outward":
      //   return getInwardOutwardData();
      default:
        return getMaterialData();
    }
  };

  const titles: Record<MaterialType, string> = {
    Material: "Materials Shipped ",
    Location: "Locations",
    "Inward/Outward": "Inward/Outward",
  };

  const dropdownRender = (menu: React.ReactElement) => (
    <div
      style={{
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        overflow: "hidden",
      }}
    >
      {menu}
    </div>
  );

  const optionLabelRender = (label: string, isSelected: boolean) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          border: `2px solid ${isSelected ? "#ff4d4f" : "#cccccc"}`,
          borderRadius: "50%",
          marginRight: "10px",
          position: "relative",
        }}
      >
        {isSelected && (
          <span
            style={{
              content: '""',
              display: "block",
              width: "6px",
              height: "6px",
              backgroundColor: "#ff4d4f",
              borderRadius: "50%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        )}
      </span>
      {label}
    </div>
  );

  return (
    <div
      style={{
        padding: "30px 0",
        border: "1px solid #EAECF0",
        margin: "20px 0",
        height: "90%",
        borderRadius: "8px",
        background: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          padding: "0 20px",
          justifyContent: "space-between",
          borderBottom: "2px solid #ECECEC",
        }}
      >
        <div style={{ marginBottom: "30px" }}>
          <ATitle
            content="Total Orders Shipped"
            fontSize={16}
            fontWeight={600}
            marginTop="0"
            lineHeight={"30px"}
          />
          <div
            style={{ fontSize: "32px", fontWeight: "700", lineHeight: "44px" }}
          >
            {getTotalCount()}
          </div>
        </div>
        <Select
          value={material}
          onChange={handleChange}
          dropdownRender={dropdownRender}
          style={{
            width: 150,
            marginBottom: "20px",
            borderRadius: "8px",
            border: "none",
            backgroundColor: "transparent",
          }}
          optionLabelProp="label"
        >
          <Option
            value="Material"
            label={optionLabelRender("Material", material === "Material")}
          >
            {optionLabelRender("Material", material === "Material")}
          </Option>
          {/* <Option
            value="Location"
            label={optionLabelRender("Location", material === "Location")}
          >
            {optionLabelRender("Location", material === "Location")}
          </Option>
          <Option
            value="Inward/Outward"
            label={optionLabelRender(
              "Inward/Outward",
              material === "Inward/Outward"
            )}
          >
            {optionLabelRender("Inward/Outward", material === "Inward/Outward")}
          </Option> */}
        </Select>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <AText fontSize={12} fontWeight={500} color={color.DARK}>
          {titles[material]}
        </AText>
        <div
          style={{
            display: "flex",
            width: "100%",
            maxWidth: "500px",
            paddingLeft: "50px",
            justifyContent: "center",
          }}
        >
          <PieChart
            data={getChartData()}
            options={{
              plugins: {
                datalabels: {
                  color: "#333333",
                  font: {
                    weight: "bold",
                  },
                  formatter: (value: any, ctx: any) => {
                    return value + "%";
                  },
                  anchor: "end",
                  align: "end",
                  offset: 10,
                },
                legend: {
                  position: "right",
                  align: "start",
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}
